import { createAction, props } from '@ngrx/store';
export enum ActionTypes {
    GET_WORKSTOCK_COUNTER_SUCCESS = '[Workstock Counter API] Workstock counter loaded successfully',
    GET_WORKSTOCK_COUNTER_FAIL = '[Workstock Counter API] Failed to load workstock counter',
    GET_DWSM_COUNTER_SUCCESS = '[DWSM Counter API] DWSM counter loaded successfully',
    GET_DWSM_COUNTER_FAIL = '[DWSM Counter API] Failed to load DWSM counter',
    GET_LOAD_FAVORITE_COUNTER = '[Workstock Sub Counters API] Load favorite counter',
    GET_WORKSTOCK_SUB_COUNTERS_SUCCESS = '[Workstock Sub Counters API] Workstock sub counters loaded successfully',
    GET_WORKSTOCK_SUB_COUNTERS_FAIL = '[Workstock Sub Counters API] Failed to load workstock sub counters'
}

export const getWorkstockCounterSuccess = createAction(ActionTypes.GET_WORKSTOCK_COUNTER_SUCCESS, props<{ workstockCounter: number }>());

export const getWorkstockCounterFail = createAction(ActionTypes.GET_WORKSTOCK_COUNTER_FAIL);

export const getDWSMCounterSuccess = createAction(ActionTypes.GET_DWSM_COUNTER_SUCCESS, props<{ dwsmCounter: number }>());

export const getDWSMCounterFail = createAction(ActionTypes.GET_DWSM_COUNTER_FAIL);

export const loadFavoriteCounter = createAction(ActionTypes.GET_LOAD_FAVORITE_COUNTER);

export const getWorkstockSubCountersNavSuccess = createAction(ActionTypes.GET_WORKSTOCK_SUB_COUNTERS_SUCCESS, props<{ favoriteCounter: number }>());

export const getWorkstockSubCountersNavFail = createAction(ActionTypes.GET_WORKSTOCK_SUB_COUNTERS_FAIL);
